module.exports = __webpack_public_path__ + "./images/4d1cbc429df6b4037c6e3ed52cb8b7a3.webp";